<template>
  <div>
    <el-form :inline="true" ref="form" size="mini" label-width="150px">
      <el-form-item :label="$t('dayinmobanmingcheng')" required>
        <el-select @change="change" v-model="printTemplateId" placeholder="请选择">
          <el-option v-for="printTemplate in printTemplateList" :label="printTemplate.name" :value="printTemplate.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('picihao')">
        <el-input v-model="batchNo" disabled @change="changePrintBatchNo"></el-input>
      </el-form-item>
      <!-- <el-form-item :label="$t('baozhuangguize')">
        <el-select :multiple="false" :clearable="true" v-model="packageRuleId" @change="changePackageRule" placeholder="请选择">
          <el-option v-for="packageRule in packageRuleList" :label="packageRule.code + '|' + packageRule.name" :value="packageRule.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item :label="$t('baozhuangshuliang')" required>
        <el-input-number v-model="packageNum" :min="0" @change="packageNumberChange"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('jihuashuliang')">
        <el-input v-model="printObj.mixtureWeight" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('yidayinshuliang')">
        <el-input v-model="printedQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('shengyudayinshuliang')">
        <el-input v-model="printableQuantity" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('dayinzhangshu')">
        <el-input-number :min="0" step-strictly v-model="printCount" @change="printCountChange"></el-input-number>
      </el-form-item>
    </el-form>
    <yi_print_preview v-if="printTemplateId" :printTemplateId.sync="printTemplateId" :scale="4" :printDatas="printDatas" ref="mixtureOrderPrint" @finishPrint="finishPrint" @failedPrint="failedPrint"></yi_print_preview>
    <div style="text-align: center;padding: 20px 0;">
      <el-button :loading="printLoading" @click="$emit('closeDialog')" style="width: 130px;">{{ $t('quxiao') }} </el-button>
      <el-button :loading="printLoading" type="primary" @click="print" style="width: 130px;">{{ printLoading ? $t('dayinzhong') : $t('dayin') }} </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'minture_order_print_label',
  props: {
    printObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      printLoading: false,
      printTemplateList: [],
      printTemplateId: null,
      packageRuleList: [],
      printDatas: [],
      packageRuleId: [],
      maxCount: '',
      printCount: 0,
      printData: {},
      packageNum: 0,
      batchNo: this.dayjs.unix(new Date().getTime() / 1000).format('YYYYMMDD') + '01',
      mixtureBom: [],
      printedQuantity: 0,
      printableQuantity: 0
    };
  },
  created() {
    setTimeout(() => {
      console.log(this.printObj);
      //获取混料单打印模板
      this.http.get('/web/print/template/list/by/type', { params: { type: '2' } }).then(res => {
        let itemList = res.data;
        this.printTemplateList = itemList;
      });

      //获取混料 bom
      this.http.get('/web/mixture/bom/page?pageNum=1&pageSize=10000', { params: { mixtureOrderId: this.printObj.id } }).then(res => {
        this.mixtureBom = res.data.rows;
      });
      //获取已打印数量
      this.http.get('/web/print/record/list', { params: { orderId: this.printObj.id, businessType: '13', validStatus: 1 } }).then(res => {
        res.data.forEach(item => {
          this.printedQuantity += item.packageNumber;
        });
        this.printableQuantity = this.printObj.mixtureWeight - this.printedQuantity;
      });
    }, 300);
  },
  methods: {
    print() {
      if (!this.printTemplateId) {
        this.$message.error(this.$t('qingxuanzedayinmoban'));
        return;
      }
      if (!this.packageNum) {
        this.$message.error(this.$t('baozhuangshuliang') + this.$t('不能为空'));
        return;
      }
      // if (this.printCount * this.packageNum > this.printableQuantity) {
      //   this.$message.error('超过可打印的最大数量');
      //   return;
      // }
      let formData = this.utils.copy(this.printData);
      formData.mixtureOrderId = this.printObj.id;
      formData.printTemplateId = this.printTemplateId;
      this.printLoading = true;
      this.http
        .post('/web/mixture/order/print', formData)
        .then(res => {
          this.printDatas = [];
          res.data.forEach(item => {
            this.printDatas.push(item);
          });
          this.$refs.mixtureOrderPrint.print();
          this.printLoading = false;
          this.$message.success(this.$t('chenggong'));
          this.$emit('closeDialog');
        })
        .catch(e => {
          this.$message.error(this.$t(e));
        });
    },
    change() {
      if (this.mixtureBom.length > 0) {
        let mixtureRatio = '';
        for (let i = 0; i < this.mixtureBom.length; i++) {
          if (i >= 5) {
            mixtureRatio += '......';
          }
          if (this.mixtureBom[i].material.spec) {
            mixtureRatio += this.mixtureBom[i].material.spec + '<br/>';
          }
        }
        this.printData.mixtureRatio = mixtureRatio;
      }
      this.printData.quantity = this.packageNum;
      this.printData.mixOrderNo = this.printObj.no;
      this.printData.woNo = this.printObj.wo.no;
      this.printData.cartonQuantity = this.printCount;
      this.printData.batchNo = this.batchNo;
      this.printDatas = [];
      this.printData.prodDate = this.printObj.finishTime ? this.dayjs.unix(this.printObj.finishTime / 1000).format('YYYY-MM-DD') : this.dayjs.unix(new Date().getTime() / 1000).format('YYYY-MM-DD');
      this.printDatas.push(this.printData);
    },
    finishPrint() {
      this.$message.success(this.$t('chenggong'));
      this.$emit('closeDialog');
      this.printLoading = false;
    },
    failedPrint() {
      this.printLoading = false;
    },
    packageNumberChange() {
      this.printData.quantity = this.packageNum;
      //计算最大打印张数
      // if (this.printCount * this.packageNum > this.printableQuantity) {
      //   this.$message.error('超过可打印的最大数量');
      // }
      this.printDatas = [];
      this.printDatas.push(this.printData);
    },
    changePrintBatchNo() {
      this.printData.batchNo = this.batchNo;
      this.printDatas = [];
      this.printDatas.push(this.printData);
    },
    printCountChange() {
      this.printData.cartonQuantity = this.printCount;
      // if (this.printCount * this.packageNum > this.printableQuantity) {
      //   this.$message.error('超过可打印的最大数量');
      // }
      this.printDatas = [];
      this.printDatas.push(this.printData);
    }
  }
};
</script>

<style scoped lang="scss"></style>
